import { bootstrap } from "bootstrap";
import LazyLoad from "vanilla-lazyload";
import $ from 'jquery';
import { awesomplete } from "awesomplete";
import SlimSelect from 'slim-select'
import { goToPageReplaceQueryStringParameter } from './global.js';
import products from './products.js';
import { bindProductEvents } from './products.js';
import AOS from 'aos';

$(document).ready(function(){
	AOS.init();
	var lazyLoadInstance = new LazyLoad({
		elements_selector: ".lazy"
	});
	bindExpandCollapseButtons();
	bindVimeoButtons();
	bindAutoCompleteInputFields();
	bindMultiSelects();
	bindRemoveTableRowButtons();
	bindModals();
	bindForms();
	bindDropdowns();
	bindFormOnSubmit();
	bindChangeFileInputImage();
	bindChangeFileInputFile();
	bindShowContainerOnClick();
	bindHideContainerOnClick();
	
	//Cookies
	if(localStorage.getItem('cookiesAccepted') == null){
		$("#cookie-container").removeClass("hide");
	}else{
		$("#cookie-container").addClass("hide");
	}
	
	$("#accept-cookies-button").unbind("click");
	$("#accept-cookies-button").bind("click",function(){
		$.ajax({
		  type: "POST",
		  url: "/api/cookies/accept",
		  data: {Accept: true},
		  success: function(data){
			  if(JSON.parse(data).message.toLowerCase() == 'true'){
				localStorage.setItem('cookiesAccepted', "true");
				$("#cookie-container").hide("400");  
			  }else{
				$("#cookie-container").show("400");   
			  }
		  }
		});
	});
	
	//Home carousel indicators color
	if($('#home-slider .carousel-item.active .home-carousel-text').hasClass("blue")){
		$('#home-slider').find(".carousel-indicators").addClass("blue");
	}
	
	$('#home-slider').on('slide.bs.carousel', function (e) {
	  var isBlueText = $(e.relatedTarget).find(".home-carousel-text").hasClass("blue");
	  
	  if(isBlueText){
		  $(this).find(".carousel-indicators").addClass("blue");
	  }else{
		  $(this).find(".carousel-indicators").removeClass("blue");
	  }
	})
	
	//Navigation
	$('#product-menu .nav-link').click(function(e){
		var productSubMenu = $(this).closest('.nav-item').find('.nav-link-content')[0];
		if(productSubMenu){
			if($(productSubMenu).css('position') === 'relative'){
				if($(productSubMenu).css('display') == 'none'){
					$(productSubMenu).slideDown({duration: 400, method: 'easeOutQuad'});
				}else{
					$(productSubMenu).slideUp({duration: 400, method: 'easeOutQuad'});
				}
				
				e.preventDefault();
			}
		}
	});
	
	//Reset menu links
	$("a[reset-menu='true']").unbind("click");
	$("a[reset-menu='true']").click(function(e){
		localStorage.mainMenuOpened = false;
	});
	
	//Main menu slide down/up
	if(localStorage.mainMenuOpened == "true" && $(window).width() >= 1200){
		$('#main-menu').css("display","block");
	}else{
		$('#main-menu').css("display","none");
	}
	
	$('#top-menu-button').click(function(){
		$('html, body').animate({ scrollTop: 0 }, 250);
		
		if($('#main-menu').css('display') == 'none'){
			$('#main-menu').slideDown({
				duration: 400,
				method: 'easeOutQuad'
			});
			
			localStorage.mainMenuOpened = true;
		}else{
			$('#main-menu').slideUp({
				duration: 400,
				method: 'easeOutQuad'
			});
			
			localStorage.mainMenuOpened = false;
		}
	});
	
	$('#close-menu-button').click(function(){
		$('#main-menu').slideUp({
			duration: 400,
			method: 'easeOutQuad'
		});
		
		localStorage.mainMenuOpened = false;
	});
	
	$(window).resize(function(){
	  if($(window).width() >= 992){
		  $('.nav-link-content').hide();
	  }
	  if($(window).width() >= 1200){
		  $('#mobile-filters-modal').modal('hide');
	  }
	  if($(window).width() >= 1300){
		  $('tr[data-detail-row=true]').hide();
	  }
	});
	
	$('.hover-dropdown-container').hover(function(){
		if($(this).find('.hover-dropdown-menu-container:first').css('display') == 'none'){
			$(this).find('.hover-dropdown-menu-container:first').slideDown({duration: 150, method: 'easeOutQuad'});
		}else{
			$(this).find('.hover-dropdown-menu-container:first').slideUp({duration: 150, method: 'easeOutQuad'});
		}
	});
	
	$('.carousel').carousel();
	
	//Table functions
	getDataForAllTables(false);
	
	$(window).scroll(function() {
		if($(window).scrollTop() + $(window).height() > $(document).height() - $("footer").height()) {
			getDataForAllTables(true);
		}
	});
	
	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		var tabId = $(this).attr("href").replace("#","");
		var tables =  $('[tab-pane-id="'+tabId+'"]');
		var tabIndex = $(this).attr("tab-index");

		if(tabIndex != undefined)
		{
			$("#TabIndex").val(tabIndex);
		}
		
		tables.each(function(e){
			var categoryId = 0;
			var dropdownFilter = $(this).attr("dropdown-filter");
			
			if(dropdownFilter != undefined)
			{
				var selectedCategoryId = $("#" + dropdownFilter).find('.dropdown-toggle span:first').attr("category-id");

				if(selectedCategoryId != undefined){
					categoryId = selectedCategoryId;
				}
			}
			
			getTableData(categoryId, $(this), "", "");
		});
	});
	
	$('th.sortable').unbind("click");
	$('th.sortable').click(function(){
		if(!tableDataIsLoading)
		{
			var arrowDown = $(this).find('.arrow-down:visible').length == 1;
			$(this).closest("table").find('.arrow-down').show();
			$(this).closest("table").find('.arrow-up').hide();
			
			if(arrowDown){
				$(this).find('.arrow-down').hide();
				$(this).find('.arrow-up').show();
			}else{
				$(this).find('.arrow-down').show();
				$(this).find('.arrow-up').hide();
			}
			
			var sortOn = $(this).attr("sort-on");
			var sortOrder = $(this).attr("sort-order");
			
			if(sortOrder == undefined)
			{
				sortOrder = -1;
			}
			
			if(sortOrder == 1){
				$(this).attr("sort-order", -1);
			}else{
				$(this).attr("sort-order", 1);
			}
			
			var table = $(this).closest('table');
			
			getTableData(getTableCategoryId(table), table, sortOn, sortOrder);
		}
	});
	
	//Search functions
	$('.search-input').keyup(function(e) {
		var input = $(this);
		
		if(input.attr('data-table') != undefined){
			searchInput(input);
		}
	});
	
	$('.search-input').on('search', function () {
		var input = $(this);
		
		if(input.attr('data-table') != undefined){
			var table = $(input.attr('data-table'));
			table.attr("search", "");
			getTableData(getTableCategoryId(table), table, "", "");
		}else if(input.attr('search-on-clear') == "true"){
			input.parent().submit();
		}
	});
	
	$('.search-button').unbind('click');
	$('.search-button').click(function(){
		if(input.attr('data-table') != undefined){
			var input = $(this).parent().find('.search-input');
			var table = $(input.attr('data-table'));
			getTableData(getTableCategoryId(table), table, "", "", input.val());
		}
	});
	
	//Radio button as tabs
	$("[linked-content]").unbind("click");
	$("[linked-content]").click(function(){		
		$('[name="'+ $(this).attr("name") +'"]').each(function(){
			$($(this).attr('linked-content')).addClass("hide");
		});
		
		$($(this).attr('linked-content')).removeClass("hide");
		
		if($(this).is(":checkbox") && !$(this).is(":checked")){
			$($(this).attr('linked-content')).addClass("hide");
		}
	});
	
	//Open date input when clicking on value
	$("input[type='date']").unbind("click");
	$("input[type='date']").click(function(){
		$(this).focus();
	});
	
	//Add/remove table row functionality
	$(".add-table-row-button").unbind("click");
	$(".add-table-row-button").click(function(e){
		var rowIndex = $(this).closest("tr").index();
		var table = $(this).closest(".table");
		var awesompleteCount = $(".awesomplete").length + 1;
		
		var template = $("#" + $(this).attr("row-template")).html();
		template = template.replace('class="awesomplete', 'id="awesomplete'+awesompleteCount+'" class="awesomplete');
		template = template.replace(new RegExp('{rowCount}', 'g'), rowIndex);

		table.find('tbody tr').eq(rowIndex-1).after(template);
		new Awesomplete("#awesomplete" + awesompleteCount);
			
		bindRemoveTableRowButtons();
		bindAutoCompleteInputFields();
		
		e.preventDefault();
	});
	
	//Custom file input
	$('input[type="file"]').on('change',function(){		
		var form = $(this).closest("form");
		form.find('input[type="submit"]').trigger("click");
    });
	
	$(".custom-upload-button").unbind("click");
	$(".custom-upload-button").click(function(e){
		var form = $(this).closest("form");
		form.find('input[type="file"]').trigger("click");
		
		e.preventDefault();
	});
	
	//Newsletter
	$(".newsletter-button").unbind("click");
	$(".newsletter-button").click(function(e){
		var button = $(this);
		var form = $(this).closest('.newsletter-form');
				
		if (!form[0].checkValidity()){
			button.click();
		}else{
			var email = form.find('input[name="Email"').val();
			var approvedPrivacyConditions = form.find('input[name="ApprovedPrivacyConditions"').is(":checked");
			
			$.ajax({
			  type: "POST",
			  url: "/newsletter/subscribe",
			  data: { Email: email, ApprovedPrivacyConditions: approvedPrivacyConditions},
			  success: function(returnUrl){
				  form.find(".alert-danger").addClass("hide");
				  window.location = returnUrl;
			  },
			  error: function(error){
				  form.find(".alert-danger").html(error.responseJSON.message);
				  form.find(".alert-danger").removeClass("hide");
			  }
			});
		}
		
		e.preventDefault();
	});
	
	//Parent checkbox
	$('[parent-checkbox="true"').unbind("click");
	$('[parent-checkbox="true"').click(function(e){
		if($(this).is(":checked")){
			$('[parent-checkbox-value="'+$(this).attr("value")+'"]').prop("checked", true);
			$('[parent-checkbox-value="'+$(this).attr("value")+'"]').parent().removeClass("hide");
		}else{
			$('[parent-checkbox-value="'+$(this).attr("value")+'"]').prop("checked", false);
			$('[parent-checkbox-value="'+$(this).attr("value")+'"]').parent().addClass("hide");
		}
	});
	
	//Color pickers
	$(".color-picker").each(function(e){
		$("[color-input='#"+$(this).attr("id")+"']").val($(this).val());
	});
	
	$(".color-picker").unbind("keyup");
	$('.color-picker').keyup(function(e){
		$(this).css('background-color', $(this).val());
		$("[color-input='#"+$(this).attr("id")+"']").val($(this).val());
	});
	
	//Get color from image
	var img = $('[get-img-colors="true"]')[0];
	if(typeof extractColors !== 'undefined') {
		if(img != undefined){
			if (img.complete) {
				extractColors.default(img).then(function(colors){
					var colorBlocks = $($(img).attr("img-color-blocks"));
					
					for(let i = 0; i < colorBlocks.length; i++){
						if(colors[i] != undefined){
							$(colorBlocks[i]).css('background-color', colors[i].hex);
							$(colorBlocks[i]).attr('color', colors[i].hex);
							$("[color-block='#"+$(colorBlocks[i]).attr("id")+"']").val(colors[i].hex);
						}else{
							$(colorBlocks[i]).parent().addClass("hide");
						}
					}
				});
			} else {
				img.addEventListener('load', function() {
					extractColors.default(img).then(function(colors){
						var colorBlocks = $($(img).attr("img-color-blocks"));
						
						for(let i = 0; i < colorBlocks.length; i++){
							if(colors[i] != undefined){
								$(colorBlocks[i]).css('background-color', colors[i].hex);
								$(colorBlocks[i]).attr('color', colors[i].hex);
								$("[color-block='#"+$(colorBlocks[i]).attr("id")+"']").val(colors[i].hex);
							}else{
								$(colorBlocks[i]).parent().addClass("hide");
							}
						}
					});
				});
			}
		}
	}
		
	//Custom file input
	$("[file-input-id]").unbind("click");
	$("[file-input-id]").click(function(e){
		$("#"+$(this).attr("file-input-id")).trigger("click");
		
		e.preventDefault();
	});
});

var delayTimer;
function searchInput(input)
{
	clearTimeout(delayTimer);
	delayTimer = setTimeout(function() {
		var table = $(input.attr('data-table'));
		getTableData(getTableCategoryId(table), table, "", "", input.val());
	}, 800);
}

function getDataForAllTables(append)
{
	$('table[data-url]').each(function(e){
		var searchInput = $($(this).attr("search-key-input"));
		var search = null;
		
		if(searchInput != undefined){
			search = searchInput.val();
		}		
		getTableData(getTableCategoryId($(this)), $(this),"", "", search, append);
	});
}

var tableDataIsLoading = false;
function getTableData(categoryId, table, sortOn, sortOrder, searchValue, append){
	if(!tableDataIsLoading || !append)
	{
		tableDataIsLoading = true;
		var queryString = "";
		
		//Sort
		var sort = "";
		if(sortOn != ""){
			sort = "sort=" + sortOn + "," + sortOrder;
			table.attr("sort", sort);
		}else if(table.attr("sort") != undefined){
			sort = table.attr("sort");
		}

		queryString += "&" + sort;
		
		//Search
		var search = "";
		if(searchValue != null && searchValue != undefined){
			search = "search=" + searchValue;
			table.attr("search", search);
		}else if(table.attr("search") != undefined){
			search = table.attr("search");
		}
		
		queryString += "&" + search;
		
		//Rowcount
		var totalItems = table.attr("total-items");
		var itemsPerRequest = table.attr("items-per-request");
		var rowCount = append ? table.find("tbody tr:not(.preloader,[data-detail-row='true'],.sub-row)").length : 0;

		if(itemsPerRequest > 0)
		{
			queryString += "&rowCount=" + rowCount + "&itemsPerRequest=" + itemsPerRequest;
		}
		
		//Update querystring
		if(queryString.length > 0)
		{
			queryString = "?" + queryString.substr(1, queryString.length);
		}
		
		//Get templates
		var rowTemplate = $(table.attr('data-row-template')).html();
		var rowTemplateAlternative = $(table.attr('data-row-template-alternative')).html();
		var rowTemplateAlternativeOnPropertyEmpty = table.attr('data-row-template-alternative-on-property-empty');
		
		//Get url
		var url = table.attr('data-url');

		if(rowCount < totalItems || !append){
			//Set current table
			if(!append){
				table.find('tbody').find('tr:not(.preloader)').remove();
				table.find('.preloader').show();
			}

			$.get(url + '/' + categoryId + queryString, function(data) {
				table.find('.preloader').hide();

				for(var i = 0; i < data.length; i++)
				{
				  if(i == 0 && data[i].totalCount != undefined){
					  table.attr("total-items" , data[i].totalCount)
				  }
				  
				  var keys = Object.keys(data[i]);
				  var currentRow = JSON.parse(JSON.stringify($("<div/>").append(rowTemplate).html()));
				  
				  if(rowTemplateAlternativeOnPropertyEmpty != undefined)
				  {
					var propertyEmpty = data[i][rowTemplateAlternativeOnPropertyEmpty]; 

					if(propertyEmpty == "" || propertyEmpty == null || propertyEmpty == undefined){
					  currentRow = JSON.parse(JSON.stringify($("<div/>").append(rowTemplateAlternative).html())); 
					}	
				  }

				  for(var k = 0; k < keys.length; k++)
				  {
					if(data[i][keys[k]] !== null && 
					   data[i][keys[k]] !== undefined && 
					   data[i][keys[k]] !== ''){
						if($(currentRow).find("[for='item."+keys[k]+"']").length > 0){
							//If list of items
							var forTemplates = $(currentRow).find("[for='item."+keys[k]+"']");
							
							for(var ft = 0; ft < forTemplates.length; ft++){
								var forTemplate = forTemplates[ft].outerHTML;
								var forItems = "";

								for(var ii = 0; ii < data[i][keys[k]].length; ii++){
									var forKeys = Object.keys(data[i][keys[k]][ii]);
									var forItem = forTemplate;
									
									for(var fk = 0; fk < forKeys.length; fk++)
									{
										var property = data[i][keys[k]][ii][forKeys[fk]];
										property = property || "";
										forItem = forItem.replace(new RegExp('{item.'+keys[k]+ '.' + forKeys[fk] + '}', 'g'), property); 
									}
									forItems += forItem;
								}
								currentRow = currentRow.replace(new RegExp(forTemplate, 'g'), forItems);
							}
						}else{
							//If one item
							currentRow = currentRow.replace(new RegExp('{item.'+keys[k]+'}', 'g'), data[i][keys[k]]); 
						}		
					}else{
						//If the property is empty
						$(currentRow).find('[data-property="item.'+keys[k]+'"]').each(function(){
							var htmlToReplace = $(this)[0].outerHTML.replace('=""', '');
							currentRow = currentRow.replace(htmlToReplace,'');	
						});
						
						currentRow = currentRow.replace(new RegExp('{item.' + keys[k] + '}', 'g'), '');
						$(currentRow).find('[data-property="item.' + keys[k] + '"]').each(function () {
							var htmlToReplace = $(this)[0].outerHTML;
							currentRow = currentRow.replace(htmlToReplace, '');
						});
					}
				  }
				  table.find('tbody').append(currentRow);
				  table.find("[hide-property='true']").addClass("hide");
				  table.find("[hide-property-mobile='true']").addClass("hide-mobile");
				  table.find("[hide-property-mobile='truetrue']").addClass("hide-mobile");
				}

				bindExpandCollapseButtons();
				bindProductEvents();
				bindVimeoButtons();
				bindClickableRows();
				bindModals();
				bindForms();
				
				$('[data-toggle="tooltip"]').tooltip();
				
				tableDataIsLoading = false;
			}).fail(function() {
				tableDataIsLoading = false;
				table.find('.preloader').hide();
			});
		}else{
			tableDataIsLoading = false;
		}
	}	
}

function getTableCategoryId(table)
{
	var categoryId = 0;
	var dropdownFilter = table.attr("dropdown-filter");
	if(dropdownFilter != undefined){
		var selectedCategoryId = $("#" + dropdownFilter).find('.dropdown-toggle span:first').attr("category-id");

		if(selectedCategoryId != undefined){
			categoryId = selectedCategoryId;
		}
	}
	
	return categoryId;
}

function bindExpandCollapseButtons(){
	$('.expand-button').unbind('click');
		$('.expand-button').click(function(e){
			var dataId = $(this).closest('tr').attr('data-id');
			
			$('tr[data-detail-row=true][data-id='+dataId+']').show();				
			$(this).parent().find('.collapse-button:first').show();
			$(this).hide();
		});
		
		$('.collapse-button').unbind('click');
		$('.collapse-button').click(function(e){
			var dataId = $(this).closest('tr').attr('data-id');
			$('tr[data-detail-row=true][data-id='+dataId+']').hide();				
			$(this).parent().find('.expand-button:first').show();
			$(this).hide();
		});
}

function bindVimeoButtons(){
	$(".vimeo-modal-link").unbind("click");
	$(".vimeo-modal-link").click(function(e){
		$("#vimeo-modal iframe:first").attr("src", $(this).attr("href"));
		$('#vimeo-modal').modal();
		
		$("#vimeo-modal").on("hidden.bs.modal", function () {
			$("#vimeo-modal iframe:first").attr("src", "");
		});
				
		e.preventDefault();
	});
}

function bindClickableRows(){
	$(".clickable-row").click(function(e) {
		if($(e.target).is("td") || $(e.target).is("tr")){
			window.location = $(this).data("href");
		};
    });
}

function bindDropdowns(){
	$('.dropdown-toggle').click(function(e){
		//Close interfering slim selects
		$(".ss-multi-selected").removeClass("ss-open-below");
		$(".ss-content").removeClass("ss-open");
	});
	
	$('.dropdown-item').click(function(e){
		var dropdown = $(this).closest('.dropdown');
		var categoryId = $(this).attr('category-id');
		var sortBy = $(this).attr('sort-by');
	
		if(categoryId != undefined)
		{
			//Set forms and other dropdowns
			$("#CategoryId").val(categoryId);
			$("a.dropdown-item").each(function(e){
				var newHref = $("a.dropdown-item").attr("href").replace(/(categoryId=).*?(&)/,'$1' + categoryId + '$2');

				$("a.dropdown-item").attr("href", newHref);
			});
			
			var categoryName = $(this).html();
			dropdown.find('.dropdown-toggle span:first').html(categoryName);
			dropdown.find('.dropdown-toggle span:first').attr("category-id",$(this).attr("category-id"));

			var tables = $(dropdown.attr('data-table'));
			
			tables.each(function(e){
				getTableData(categoryId, $(this), "", "");
			});
		}else if (sortBy != undefined){
			goToPageReplaceQueryStringParameter("sort=" + sortBy + "," + $(this).attr("sort"), true);
		}else{
			var dataId = $(this).attr("data-id");
			
			dropdown.find('.dropdown-toggle span:first').html($(this).html());
			dropdown.find('.dropdown-toggle span:first').attr("data-id",$(this).attr("data-id"));
			dropdown.find('input').val(dataId);
			
			//Check if there are elements linke to the data-id of this dropdown value to hide or show
			var linkedContent = $("[linked-content-id=" + dataId + "]");
			if(linkedContent.length > 0){
				var linkedElements = linkedContent.closest(".linked-content-container").find("[linked-content-id]");
				for(var i = 0; i < linkedElements.length; i++){
					var currentElement = $(linkedElements[i]);
					currentElement.addClass("hide");
					deactivateFormElements(currentElement);
				}
				
				linkedContent.removeClass("hide");
				activateFormElements(linkedContent);
			}
		}
	});
}

function bindModals(){
	$("[modal]").unbind("click");
	$("[modal]").click(function(e){
		var button = $(this);
		var modalContentTemplate = $(button.attr("modal-content")).html();
		var dataUrl = button.attr("data-url");

		if(dataUrl != undefined && dataUrl != null){
			$.get(dataUrl, function(data) {
				var keys = Object.keys(data);
				for(var k = 0; k < keys.length; k++)
				{	
					if(data[keys[k]] !== null && 
						data[keys[k]] !== undefined && 
						data[keys[k]] !== ''){
						modalContentTemplate = modalContentTemplate.replace(new RegExp('{item.'+keys[k]+'}', 'g'), data[keys[k]]);  
					}
				}
				
				modalContentTemplate = modalContentTemplate.replace(/{.+}/g,"");
				
				$(button.attr("modal")).find(".modal-content").html(modalContentTemplate);
				$(button.attr("modal")).modal();
				bindModalCloseEvent(button.attr("modal"));
				bindDropdowns();
				bindFormOnSubmit();
				bindAutoCompleteInputFields();
			});
		}else{
			modalContentTemplate = modalContentTemplate.replace(/{.+}/g,"");
				
			$(button.attr("modal")).find(".modal-content").html(modalContentTemplate);
			$(button.attr("modal")).modal();
			
			bindDropdowns();
			bindFormOnSubmit();
			bindAutoCompleteInputFields();
		}
				
		e.preventDefault();
	});
	
	$(".modal[show-on-load=true]").each(function(){
		$(this).modal();
		
		bindModalCloseEvent($(this));
	});
}

function bindModalCloseEvent(modal){
	var actionWhenHidden = $(modal).attr("action-when-hidden");
	if(actionWhenHidden != undefined){
		$(modal).on("hidden.bs.modal", function () {
			$.ajax({
			  type: "POST",
			  url: actionWhenHidden
			});
		});
	}
}

function bindForms(){        
    $('.table form button[type=submit]').click(function(e){
        $(this).closest("form").submit();
    });
}

function bindAutoCompleteInputFields(){
	 var currentRequest = null;    

	$('.awesomplete').unbind('keyup');
	$('.awesomplete').keyup(function(){
		var input = $(this);
		var url = input.attr('api-url');

		if(url != undefined)
		{
			currentRequest = $.ajax({
			  type: "POST",
			  url: url + '/' + input.val(),
			  beforeSend : function()    {           
				if(currentRequest != null) {
					currentRequest.abort();
				}
			  },
			  success: function(data){
				  var parentElement = input.parent().parent();
				  input.parent().remove();
				  parentElement.append(input);
				  
				  if(input.attr('id') == undefined){
					  var awesompleteCount = $('.awesomplete').length + 1;
					  input.attr('id', 'awesomplete' + awesompleteCount);
				  }
					
				  var newAutocomplete = new Awesomplete('#' + input.attr("id"), 
				  { 
					list: data,
					autoFirst:true,
					replace: function(suggestion) {
						this.input.value = stripHtml(suggestion.label);
						$(this.input).attr("value-on-submit", suggestion.value);
					},
					maxItems: 100
				  });
				  
				  newAutocomplete.evaluate();
				  input.focus();
				  bindAutoCompleteInputFields();
			  }
			});
		}
	});
}

function stripHtml(html)
{
   let tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
}

function bindMultiSelects(){
	$(".slim-select").each(function(index){
		var currentSelect = $(this);
		
		new SlimSelect({
			select: '#'+ currentSelect.attr("id"),
			searchText: currentSelect.attr("noResultsText"),
			searchPlaceholder: currentSelect.attr("searchPlaceholder"),
			ajax: currentSelect.attr("api-url") != undefined ? function (search, callback){
				if (search.length < 3) {
				  callback(currentSelect.attr("minCharactersText"))
				  return
				}

				fetch(currentSelect.attr("api-url") + "/" + search)
				.then(function (response) {
				  return response.json()
				})
				.then(function (json) {
				  let data = []
				  for (let i = 0; i < json.length; i++) {
					if(json[i].text){
						data.push({text: json[i].text, value:json[i].value})
					}else{
						data.push({text: json[i], value:json[i]})
					}
				  }

				  callback(data)
				})
				.catch(function(error) {
				  callback(false)
				})
		    } : null,
		    placeholder: currentSelect.attr("placeholder"),
			onChange: function(){
				if($(currentSelect).attr("submitForm")){
					$($(currentSelect).attr("submitForm")).submit();
				}
			}
		});
	});
}

function bindRemoveTableRowButtons()
{
	$('.remove-row-button').unbind('click');
	$('.remove-row-button').click(function(e){
		var table = $(this).closest(".table");

		$(this).closest('tr').remove();
		
		//Number items according to row index
		for(var i = 0; i < table.find('tr').length; i++){
			var tds = table.find('tbody tr').eq(i).find('td');
			
			for(var ii = 0; ii < tds.length; ii++){
				if(tds.eq(ii).find('input').length == 1){
					var name = tds.eq(ii).find('input:first').attr("name");
					var firstOpeningBracketIndex = name.indexOf('[');
					var firstClosingBracketIndex = name.indexOf(']');
					var newName = name.substr(0, firstOpeningBracketIndex) + '[' + i + name.substring(firstClosingBracketIndex, name.length);
					
					tds.eq(ii).find('input').attr('name', newName);
				}
			}
		}
		
		e.preventDefault();
	});
	
	$(".remove-row-btn").click(function(e){
		var row = $(this).closest(".row");
		row.remove();
		
		e.preventDefault();
	});
}

function deactivateFormElements(container){
	var elementsToDeactivate = container.find("input");
	
	for(var i = 0; i < elementsToDeactivate.length; i++){
		var currentElement = $(elementsToDeactivate[i]);
		
		if(currentElement.attr("name") != undefined && currentElement.attr("name").length > 0){
			currentElement.attr("hide-name", currentElement.attr("name"));
			currentElement.attr("name","");
		}
	}
}

function activateFormElements(container){
	var elementsToActivate = container.find("input");
	
	for(var i = 0; i < elementsToActivate.length; i++){
		var currentElement = $(elementsToActivate[i]);
		
		if(currentElement.attr("hide-name") != undefined && currentElement.attr("hide-name").length > 0){
			currentElement.attr("name", currentElement.attr("hide-name"));
			currentElement.attr("hide-name","");
		}
	}
}

function bindFormOnSubmit(){
	$('form:not([download]), form:not([modal])').submit(function(e) {
	  var form = $(this);
	  var inputs = form.find("[value-on-submit]");

	  for(var i = 0; i < inputs.length; i++)
	  {
		  var input = $(inputs[i]);
		  input.val(input.attr("value-on-submit"));		  
	  }
	  
	  if(form.parent().find(".preloader-container").length > 0){
		  form.parent().find(".preloader-container").removeClass("hide");
	  }	  
	});
	
	$('form[modal]').submit(function(e) {
		var form = $(this);
		form.parent().find(".preloader-container").removeClass("hide");
		form.parent().find(".preloader-container").addClass("d-inline-block");
		$.ajax({
			type: "POST",
			url: form.attr("action"),
			data: form.serialize(),
			success: function() {
				$(".modal").modal('hide');
			}
		});
	
		e.preventDefault(); 
	});
	
	$('form[download]').submit(function(e) {
		var form = $(this);
		form.parent().find(".preloader-container").removeClass("hide");
		form.parent().find(".preloader-container").addClass("d-inline-block");
		
		$.ajax({
			type: "POST",
			url: form.attr("action"),
			data: form.serialize(),
			xhrFields: {
				responseType: 'blob'
			},
			success: function(blob, status, xhr) {
				var filename = "";
				var disposition = xhr.getResponseHeader('Content-Disposition');
				if (disposition && disposition.indexOf('attachment') !== -1) {
					var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
					var matches = filenameRegex.exec(disposition);
					if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
				}

				if (typeof window.navigator.msSaveBlob !== 'undefined') {
					window.navigator.msSaveBlob(blob, filename);
				} else {
					var URL = window.URL || window.webkitURL;
					var downloadUrl = URL.createObjectURL(blob);

					if (filename) {
						var a = document.createElement("a");
						if (typeof a.download === 'undefined') {
							window.location.href = downloadUrl;
						} else {
							a.href = downloadUrl;
							a.download = filename;
							document.body.appendChild(a);
							a.click();
						}
					} else {
						window.location.href = downloadUrl;
					}

					setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100);
				}
				
				form.parent().find(".preloader-container").addClass("hide");
				form.parent().find(".preloader-container").removeClass("d-inline-block");
				
				window.scrollTo(0, 0);
				location.reload();
			}
		});
	
		e.preventDefault(); 
	});
}

function bindChangeFileInputImage(){
	$(".image-file-input").change(function(){
		var fileInput = $(this);
		var image = fileInput.get(0).files.item(0);
		var linkedImage = $(fileInput.attr("linked-img"));
		var fileReader = new FileReader();
        fileReader.readAsDataURL(image);
		fileReader.onload = function (e) {
			linkedImage.attr("src", e.target.result);
        };				
	});
}

function bindChangeFileInputFile(){
	$(".all-file-input").change(function(){
		var fileInput = $(this);
		var files = fileInput.get(0).files;
		var fileListContainer = $((fileInput).attr("file-list-container"));
		var fileListRowsTemplate = $((fileInput).attr("file-list-row-template")).html();
		
		if(fileListContainer != null && fileListRowsTemplate != null)
		{
			var fileRows = "";
			for(var i = 0; i < files.length; i++){
				fileRows += fileListRowsTemplate
				.replaceAll("{fileName}", files[i].name)
				.replaceAll("{fileCount}", i);
			}
			fileListContainer.html(fileRows);
		}
		
		bindRemoveTableRowButtons();
	});
}

function bindShowContainerOnClick(){
	$("[show-container-on-click]").click(function (e){
		$($(this).attr("show-container-on-click")).removeClass("hide");
		e.preventDefault();
	});
}

function bindHideContainerOnClick(){
	$("[hide-container-on-click]").click(function (e){
		$($(this).attr("hide-container-on-click")).addClass("hide");
		e.preventDefault();
	});
}